import StringToHSLProvider from './StringToHSL';
export default StringToHSLProvider;